import { Button } from '@digitools/honest-ui';
import { UploadIcon } from '@digitools/honest-ui/icons';
import React, { useRef } from 'react';
import useExperience from 'src/hooks/useExperience';
import { Language } from 'src/types/Language';
import { DocumentUploadDisplayTextEn } from './language/DocumentUploadDisplayTextEn';
import { DocumentUploadDisplayTextEs } from './language/DocumentUploadDisplayTextEs';
import { supportedFiles } from './UploadConstants';
// @ts-ignore
import Styles from './HonestInlineDocumentUpload.scss';
/** Same list the upload validation checks, so the picker filter can't drift from it. */
const ACCEPTED_FILE_TYPES = supportedFiles.map(extension => `.${extension}`).join(', ');
/**
 * honest-ui rebrand of `./UploadButton`, alongside the original until every upload feature is
 * converted. Forwards a ref so the parent can return focus here after deleting a row.
 */
const HonestUploadButton = React.forwardRef(({ onUpload, eventNum }, ref) => {
    const { language } = useExperience();
    const fileInputRef = useRef(null);
    const languageFile = language === Language.SPANISH ? DocumentUploadDisplayTextEs : DocumentUploadDisplayTextEn;
    return (<>
      <Button ref={ref} type={'text'} label={languageFile.uploadDocumentsButtonText} icon={<UploadIcon />} iconPosition={'leading'} className={Styles.uploadButton} data-testid={'uploadButton'} onClick={() => {
            fileInputRef.current?.click();
        }}/>
      {/* A sibling, not a child: <button> may not contain interactive content. aria-hidden
            rather than relying on `display: none` alone, so it holds if the CSS fails to load. */}
      <input className={Styles.hiddenFileInput} ref={fileInputRef} data-testid={'fileUpload' + eventNum} type={'file'} id={'file-upload' + eventNum} onChange={onUpload} accept={ACCEPTED_FILE_TYPES} aria-hidden={true}/>
    </>);
});
HonestUploadButton.displayName = 'HonestUploadButton';
export default HonestUploadButton;
